<script>

import BaseTextarea from "@/components/Base/BaseTextarea.vue";
import BaseInput from "@/components/Base/BaseInput3.vue";
import axios from "axios";
import SaveInfo from "@/components/Base/SaveInfo.vue";
import {Spin, message} from 'ant-design-vue';

message.config({
	top: '50px',      // Отступ сверху
	duration: 3,      // Продолжительность показа в секундах
	maxCount: 3,      // Максимальное количество сообщений
	zIndex: 10000000      // Увеличиваем z-index
});

export default {
	name: "CriterionItem",
	components: {SaveInfo, Spin, BaseInput, BaseTextarea},
	props: {
		criterion_id: {},
		category_id: {},
		category_name: {},
		tour: {}
	},
	data() {
		return {
			loading: false,
			criterion: null,
			isDataUpdating: false,
			variant_name: '',
			criterion_schema: {
				'name': '',
				'description': '',
				'hint': '',
				'importance': 1,
				'competitionCategory': '',
				'customAnswers': [],
				'gradingScale': null
			}
		}
	},
	mounted() {
		this.getData();
	},
	methods: {
		async getData() {
			this.loading = true;
			await this.get_criterion();
			this.loading = false
		},
		async get_criterion() {
			if (this.criterion_id.length === 0) {
				this.criterion_schema.competitionCategory = '/api/categories/' + this.category_id;
				
				if (this.tour.length > 0) {
					if (this.tour === 'NULL') {
						this.criterion_schema.tour = null;
					} else {
						this.criterion_schema.tour = this.tour;
					}
				}
				
				this.criterion = this.criterion_schema;
			} else {
				const response = await axios.get('/api/vote_criteria/' + this.criterion_id, {
					headers: {
						'Content-Type': 'application/json'
					}
				});
				
				console.log(response.data);
				
				this.criterion = response.data;
			}
		},
		async addCriterion() {
			const variant = {
				'name': this.variant_name
			};
			this.criterion.customAnswers.push(variant);
			this.saveData();
		},
		async deleteCriterian(index) {
			this.criterion.customAnswers.splice(index, 1);
			this.saveData();
		},
		async saveData() {
			if (this.criterion_id) {
				this.isDataUpdating = true;
				
				this.criterion.importance = parseFloat(this.criterion.importance);
				
				if (this.criterion.gradingScale !== null && this.criterion.gradingScale !== '') {
					this.criterion.gradingScale = parseInt(this.criterion.gradingScale);
				}
				
				await axios.patch('/api/vote_criteria/' + this.criterion_id, this.criterion, {
					headers: {
						'Content-Type': "application/merge-patch+json"
					}
				})
				message.success('Данные успешно сохранены!');
				this.isDataUpdating = false;
			}
		},
		async handleSave() {
			if (this.criterion_id.length === 0) {
				await this.submitForm();
			} else {
				await this.saveData();
			}
		},
		async submitForm() {
			this.isLoading = true;
			
			this.criterion.importance = parseFloat(this.criterion.importance);
			if (this.criterion.gradingScale !== null && this.criterion.gradingScale !== '') {
				this.criterion.gradingScale = parseInt(this.criterion.gradingScale);
			}
			
			await axios.post('/api/vote_criteria', this.criterion);
			message.success('Критерий успешно создан!');
			
			this.isLoading = false;
			this.$emit('closeModal');
		},
	}
}
</script>

<template>
	<div v-if="!loading && criterion !== null">
		<SaveInfo
			:isDataUpdating="isDataUpdating"
		></SaveInfo>
		<h1>Добавить критерий для оценки категории "{{ category_name }}"</h1>
		<BaseInput
			label="Название критерия"
			v-model="criterion.name"
			:isDataUpdated="isDataUpdating"
			@onChange="saveData"
		></BaseInput>
		
		<BaseTextarea
			label="Описание критерия"
			:isDataUpdated="isDataUpdating"
			v-model="criterion.description"
			@onChange="saveData"
		></BaseTextarea>
		
		<BaseTextarea
			label="Подсказка"
			:isDataUpdated="isDataUpdating"
			v-model="criterion.hint"
			@onChange="saveData"
		></BaseTextarea>
		
		<BaseInput
			label="Важность. По умолчанию - 1. Если нужно понизить важность критерия на 50%, укажите 0.5. Если нужно повысить важность критерия на 100%, укажите 2."
			v-model="criterion.importance"
			type="number"
			:isDataUpdated="isDataUpdating"
			@onChange="saveData"
		></BaseInput>
		
		<BaseInput
			label="Шкала оценки (пока разрабатывается). По умолчанию - 10-бальная. Укажите другое значение, если необходимо."
			v-model="criterion.gradingScale"
			type="number"
			:isDataUpdated="isDataUpdating"
			@onChange="saveData"
		></BaseInput>
		
		<p>Варианты ответов для оценок (заполнить если 10 балльная шкала оценки не нужна)</p>
		
		<div class="field">
			<div class="field_label__wrapper">
				<label class="field_label">Название варианта</label>
			</div>
			<input
				:disabled="isDataUpdating"
				name="name"
				type="text"
				v-model="variant_name"
			/>
			<button style="margin-top: 20px;" @click.prevent="addCriterion" class="button2">Добавить вариант</button>
			
			<div style="margin-top: 30px;">
				<p v-for="(item,index) in criterion.customAnswers" :key="index">{{ item.name }} - <a
					@click="deleteCriterian(index)">Удалить</a></p>
			</div>
		</div>
		
		<p style="margin-bottom: 30px; margin-top: 10px;">
			<button @click.prevent="handleSave" class="button4">Сохранить</button>
<!--			<button @click.prevent="criterion_id.length === 0 ? submitForm : saveData" class="button4">Сохранить</button>-->
		</p>
	</div>
	<div v-else>
		<Spin></Spin>
	</div>
</template>
